module.exports = __webpack_public_path__ + "static/HealthHero-5c61b10c4d7e2e65d2d86c6b5ab73b76.png";